module.exports = __webpack_public_path__ + "static/img/5.2626459.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/2/eng/5.png
// module id = lx1I
// module chunks = 0